import React from 'react';
import { styled } from '@linaria/react';

const Label = styled.label`
  font-size: var(--bb-label-font-size);
  color: var(--bb-label-color);
  padding-bottom: 6px;
  display: block;
`;

export default props => (
  <Label
    {...props}
    tabindex="-1"
  />
);
